import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { requestService } from 'src/core/services/api';
import { transactionRoutes } from './routes';
export class Transaction {
  constructor() {
    _defineProperty(this, "routes", transactionRoutes);
  }
  async checkPayment(data, options) {
    const resp = await requestService('payment').post(this.routes.checkPayment, _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async getAvaliableRefund(data, options) {
    const resp = await requestService('payment').get(this.routes.refund, _objectSpread({
      params: _objectSpread({}, data)
    }, options.cancelToken));
    return resp.data;
  }
  async applyRefund(data, options) {
    const resp = await requestService('payment').post(this.routes.refund, _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async postCredit(data, options) {
    const resp = await requestService('payment').post(this.routes.credit, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postCustomCharge(data, options) {
    const resp = await requestService('payment').post(this.routes.customCharge, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postBulkCustomCharge(data, options) {
    const resp = await requestService('payment').post(this.routes.bulkCustomCharge, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async postCustomCredit(data, options) {
    const resp = await requestService('payment').post(this.routes.customCredit, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async scheduledCustomTransaction(data, options) {
    const resp = await requestService('payment').post(this.routes.scheduledCustomTransaction, _objectSpread(_objectSpread({}, data), options.cancelToken));
    return resp.data;
  }
  async getScheduledCustomTransaction(data, options) {
    const resp = await requestService('payment').get(this.routes.scheduledCustomTransaction, _objectSpread({
      params: _objectSpread({}, data)
    }, options.cancelToken));
    return resp.data;
  }
  async putScheduledCustomTransaction(data, options) {
    const resp = await requestService('payment').put(this.routes.scheduledCustomTransactionById(data.id), data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async deleteScheduledCustomTransaction(data, options) {
    const resp = await requestService('payment').delete(this.routes.scheduledCustomTransactionById(data.id), data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async putScheduledCustomTransactionStatus(data, options) {
    const resp = await requestService('payment').put(this.routes.scheduledCustomTransactionByIdStatus(data.id), data, _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async verifyPayment(data, options) {
    const resp = await requestService('payment').post(this.routes.verifyPayment, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async voidTransaction(data, options) {
    const resp = await requestService('payment').post(this.routes.void, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
  async customTransactions(data, options) {
    const resp = await requestService('payment').post(this.routes.customTransactions, _objectSpread({}, data), _objectSpread({}, options.cancelToken));
    return resp.data;
  }
}